import config from '@/config'
import Channels from '@/models/Channels'
import { ChannelRoles } from '@/models/Users'
import { PaginationParams } from '@/types/PaginationParams'
import BaseService from './BaseService'
import { requests } from './HTTPService'

const http = requests(config?.COMMUNITIES_SERVER_URL)
export default class ChannelsService extends BaseService<Channels> {
  protected basePath = ''

  model(): typeof Channels {
    return Channels
  }

  constructor(locationId: string, groupId: string) {
    super(locationId, http)
    this.basePath = `/${locationId}/groups/${groupId}/channels`
  }

  // Create Channel
  async create(data: any): Promise<any> {
    const response = await http.post(`${this.endpoint}`, data)
    return response.data
  }

  async update(data: any): Promise<any> {
    const response = await http.patch(`${this.endpoint}/${data._id}`, data)
    return response.data
  }

  async delete(data: any): Promise<any> {
    const response = await http.delete(`${this.endpoint}/${data._id}`, data)
    return response.data
  }

  async fetchAllChannels(noCache?: boolean): Promise<any> {
    const headers = {}
    if (noCache) {
      headers['Cache-Control'] = 'no-cache'
    }
    const response = await http.get(`${this.endpoint}`, {
      headers,
    })
    return response.data
  }

  async fetchChannelsMetadata(): Promise<any> {
    const response = await http.get(`${this.endpoint}/metadata`)
    return response.data
  }

  async getChannelBySlug(slug: string): Promise<any> {
    const response = await http.get(`${this.endpoint}/slug/${slug}`)
    return response.data
  }

  async fetchChannelMembers(
    channelId: string,
    roles?: string,
    paginationParams?: PaginationParams,
    searchText?: string
  ): Promise<any> {
    const response = await http.get(`${this.endpoint}/${channelId}/users`, {
      params: {
        roles,
        searchText,
        ...paginationParams,
      },
    })
    return response.data
  }

  async addChannelMembers(membersData: any, channelId: string): Promise<any> {
    const response = await http.post(
      `${this.endpoint}/${channelId}/users`,
      membersData
    )
    return response.data
  }

  async updateMemberRole(
    channelId: string,
    contactId: string,
    role: ChannelRoles
  ): Promise<any> {
    const response = await http.patch(
      `${this.endpoint}/${channelId}/users/${contactId}?updatedRole=${role}`
    )
    return response.data
  }

  async removeUserFromChannel(
    channelId: string,
    contactId: string
  ): Promise<any> {
    const response = await http.delete(
      `${this.endpoint}/${channelId}/users/${contactId}`
    )
    return response.data
  }

  async leaveChannel(channelId: string): Promise<any> {
    const response = await http.delete(
      `${this.endpoint}/${channelId}/users/leave-channel`
    )
    return response.data
  }

  async updateChannelVisibility(
    channelId: string,
    visibility: string
  ): Promise<any> {
    const response = await http.patch(
      `${this.endpoint}/${channelId}/update-visibility?visibility=${visibility}`
    )
    return response.data
  }

  async markChannelAsRead(channelId: string): Promise<any> {
    const response = await http.post(
      `${this.endpoint}/${channelId}/mark-as-read`
    )
    return response.data
  }
}
